<div class="cash-flow-statement">
  <div class="cash-flow-statement-header">
    <div class="cash-flow-statement-header-left">
      <button title="Refresh" class="stroked-btn transparent-btn" (click)="refresh()">
        <i class="fa-regular fa-arrows-rotate"></i>
      </button>
    </div>
    <div class="cash-flow-statement-header-middle">
      <h3>{{pageHeading}}</h3>
    </div>
  </div>
  <div class="cash-flow-statement-body">
    <div class="cash-flow-statement-body-headerdetails">
      <div class="cash-flow-statement-body-headerdetails-left">
        <div class="col-name">
          <p class="ellipse">group name</p>
        </div>
      </div>
      <div class="cash-flow-statement-body-headerdetails-right">
        <div class="col-datemonthyear flex-box-vc-hr">
          <p class="ellipse" title="{{currentYear | date: 'MMMM d'}}">{{currentYear | date: 'MMMM d'}}</p>
          <p class="ellipse" title="{{currentYear | date: 'y'}}">{{currentYear | date: 'y'}}</p>
        </div>
        <div class="col-datemonthyear flex-box-vc-hr">
          <p class="ellipse heading-color" title="{{previousYear | date: 'MMMM d'}}">{{previousYear | date: 'MMMM d'}}</p>
          <p class="ellipse heading-color" title="{{previousYear | date: 'y'}}">{{previousYear | date: 'y'}}</p>
        </div>
      </div>
    </div>
    <div class="cash-flow-statement-body-content">
      <ul>
        <li class="cash-flow-no-child" *ngFor="let data of cashFlowData">
          <div class="cash-flow-no-child-content">
            <div class="col-nameamt" title="{{data.name}}">
              <h6 class="ellipse no-marg">{{data.name}}</h6>
            </div>
            <div class="cash-flow-no-child-content-right">
              <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.currentamount == '0' || data.currentamount == '0.00' || data.currentamount == null ? '-' : data.currentamount}}">
                <h6 class="ellipse no-marg">{{data.currentamount == '0' || data.currentamount == '0.00' || data.currentamount == null ? '-' : data.currentamount}}</h6>
              </div>
              <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.previousamount == '0' || data.previousamount == '0.00' || data.previousamount == null ? '-' : data.previousamount}}">
                <h6 class="ellipse no-marg heading-color">{{data.previousamount == '0' || data.previousamount == '0.00' || data.previousamount == null ? '-' : data.previousamount}}</h6>
              </div>
            </div>
          </div>
          <div class="cash-flow-no-child-content">
            <div class="col-nameamt" title="{{data.noncash.name}}">
              <h6 class="ellipse no-marg">{{data.noncash.name}}</h6>
            </div>
            <div class="cash-flow-no-child-content-right">
              <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.noncash.currentamount == '0' || data.noncash.currentamount == '0.00' || data.noncash.currentamount == null ? '-' : data.noncash.currentamount}}">
                <h6 class="ellipse no-marg">{{data.noncash.currentamount == '0' || data.noncash.currentamount == '0.00' || data.noncash.currentamount == null ? '-' : data.noncash.currentamount}}</h6>
              </div>
              <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.noncash.previousamount == '0' || data.noncash.previousamount == '0.00' || data.noncash.previousamount == null ? '-' : data.noncash.previousamount}}">
                <h6 class="ellipse no-marg heading-color">{{data.noncash.previousamount == '0' || data.noncash.previousamount == '0.00' || data.noncash.previousamount == null ? '-' : data.noncash.previousamount}}</h6>
              </div>
            </div>
          </div>
          <ul>
            <li class="cash-flow-child" *ngFor="let child of data.parents">
              <div class="cash-flow-child-header" title="{{child.lineitemname}}">
                <h6 class="ellipse no-marg heading-title">{{child.lineitemname}}</h6>
              </div>
              <ul>
                <li class="cash-flow-child-elements" *ngFor="let subChild of child.childs">
                  <div class="cash-flow-child-elements-content-left">
                    <div class="col-nameamt" title="{{subChild.lineitemname}}">
                      <p class="ellipse no-marg">{{subChild.lineitemname}}</p>
                    </div>
                  </div>
                  <div class="cash-flow-child-elements-content-right">
                    <!-- <ng-container *ngFor="let amt of subChild.amount"> -->
                      <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{subChild.currentamount == '0' || subChild.currentamount == '0.00' || subChild.currentamount == null ? '-' : subChild.currentamount}}">
                        <p class="ellipse no-marg">{{subChild.currentamount == '0' || subChild.currentamount == '0.00' || subChild.currentamount == null ? '-' : subChild.currentamount}}</p>
                      </div>
                      <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{subChild.previousamount == '0' || subChild.previousamount == '0.00' || subChild.previousamount == null ? '-' : subChild.previousamount}}">
                        <p class="ellipse no-marg heading-color">{{subChild.previousamount == '0' || subChild.previousamount == '0.00' || subChild.previousamount == null ? '-' : subChild.previousamount}}</p>
                      </div>
                    <!-- </ng-container> -->
                  </div>
                </li>
              </ul>
              <ul>
                <li class="cash-flow-statement-total">
                  <div class="cash-flow-statement-total-left">
                    <div class="col-nameamt" title="{{child.bottomparents.lineitemname}}">
                      <h6 class="ellipse no-marg">{{child.bottomparents.lineitemname}}</h6>
                    </div>
                  </div>
                  <div class="cash-flow-statement-total-right">
                    <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{child.bottomparents.currentamount == '0' || child.bottomparents.currentamount == '0.00' || child.bottomparents.currentamount == null ? '-' : child.bottomparents.currentamount}}">
                      <h6 class="ellipse no-marg">{{child.bottomparents.currentamount == '0' || child.bottomparents.currentamount == '0.00' || child.bottomparents.currentamount == null ? '-' : child.bottomparents.currentamount}}</h6>
                    </div>
                    <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{child.bottomparents.previousamount == '0' || child.bottomparents.previousamount == '0.00' || child.bottomparents.previousamount == null ? '-' : child.bottomparents.previousamount}}">
                      <h6 class="ellipse no-marg heading-color">{{child.bottomparents.previousamount == '0' || child.bottomparents.previousamount == '0.00' || child.bottomparents.previousamount == null ? '-' : child.bottomparents.previousamount}}</h6>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
          <ul>

            <li class="cash-flow-child-elements">
              <div class="cash-flow-child-elements-content-left">
                <div class="col-nameamt" title="{{data.cflastnames.lineitemname}}">
                  <p class="ellipse no-marg">{{data.cflastnames.lineitemname}}</p>
                </div>
              </div>
              <div class="cash-flow-child-elements-content-right">
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames.currentamount == '0' || data.cflastnames.currentamount == '0.00' || data.cflastnames.currentamount == null ? '-' : data.cflastnames.currentamount}}">
                  <p class="ellipse no-marg">{{data.cflastnames.currentamount == '0' || data.cflastnames.currentamount == '0.00' || data.cflastnames.currentamount == null ? '-' : data.cflastnames.currentamount}}</p>
                </div>
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames.previousamount == '0' || data.cflastnames.previousamount == '0.00' || data.cflastnames.previousamount == null ? '-' : data.cflastnames.previousamount}}">
                  <p class="ellipse no-marg heading-color">{{data.cflastnames.previousamount == '0' || data.cflastnames.previousamount == '0.00' || data.cflastnames.previousamount == null ? '-' : data.cflastnames.previousamount}}</p>
                </div>
              </div>
            </li>

            <li class="cash-flow-statement-total">
              <div class="cash-flow-statement-total-left">
                <div class="col-nameamt group-name" title="{{data.cflastnames2.lineitemname}}">
                  <h6 class="ellipse no-marg">{{data.cflastnames2.lineitemname}}</h6>
                </div>
              </div>
              <div class="cash-flow-statement-total-right">
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames2.currentamount == '0' || data.cflastnames2.currentamount == '0.00' || data.cflastnames2.currentamount == null ? '-' : data.cflastnames2.currentamount}}">
                  <h6 class="ellipse no-marg">{{data.cflastnames2.currentamount == '0' || data.cflastnames2.currentamount == '0.00' || data.cflastnames2.currentamount == null ? '-' : data.cflastnames2.currentamount}}</h6>
                </div>
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames2.previousamount == '0' || data.cflastnames2.previousamount == '0.00' || data.cflastnames2.previousamount == null ? '-' : data.cflastnames2.previousamount}}">
                  <h6 class="ellipse no-marg heading-color">{{data.cflastnames2.previousamount == '0' || data.cflastnames2.previousamount == '0.00' || data.cflastnames2.previousamount == null ? '-' : data.cflastnames2.previousamount}}</h6>
                </div>
              </div>
            </li>
            <li class="cash-flow-statement-total">
              <div class="cash-flow-statement-total-left">
                <div class="col-nameamt group-name" title="{{data.cflastnames3.lineitemname}}">
                  <h6 class="ellipse no-marg">{{data.cflastnames3.lineitemname}}</h6>
                </div>
              </div>
              <div class="cash-flow-statement-total-right">
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames3.currentamount == '0' || data.cflastnames3.currentamount == '0.00' || data.cflastnames3.currentamount == null ? '-' : data.cflastnames3.currentamount}}">
                  <h6 class="ellipse no-marg">{{data.cflastnames3.currentamount == '0' || data.cflastnames3.currentamount == '0.00' || data.cflastnames3.currentamount == null ? '-' : data.cflastnames3.currentamount}}</h6>
                </div>
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames3.previousamount == '0' || data.cflastnames3.previousamount == '0.00' || data.cflastnames3.previousamount == null ? '-' : data.cflastnames3.previousamount}}">
                  <h6 class="ellipse no-marg heading-color">{{data.cflastnames3.previousamount == '0' || data.cflastnames3.previousamount == '0.00' || data.cflastnames3.previousamount == null ? '-' : data.cflastnames3.previousamount}}</h6>
                </div>
              </div>
            </li>
            <li class="cash-flow-statement-total final-statement">
              <div class="cash-flow-statement-total-left">
                <div class="col-nameamt group-name" title="{{data.cflastnames4.lineitemname}}">
                  <h6 class="ellipse no-marg">{{data.cflastnames4.lineitemname}}</h6>
                </div>
              </div>
              <div class="cash-flow-statement-total-right">
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames4.currentamount == '0' || data.cflastnames4.currentamount == '0.00' || data.cflastnames4.currentamount == null ? '-' : data.cflastnames4.currentamount}}">
                  <h6 class="ellipse no-marg">{{data.cflastnames4.currentamount == '0' || data.cflastnames4.currentamount == '0.00' || data.cflastnames4.currentamount == null ? '-' : data.cflastnames4.currentamount}}</h6>
                </div>
                <div class="col-datemonthyear-amt flex-box-vc-hr" title="{{data.cflastnames4.previousamount == '0' || data.cflastnames4.previousamount == '0.00' || data.cflastnames4.previousamount == null ? '-' : data.cflastnames4.previousamount}}">
                  <h6 class="ellipse no-marg heading-color">{{data.cflastnames4.previousamount == '0' || data.cflastnames4.previousamount == '0.00' || data.cflastnames4.previousamount == null ? '-' : data.cflastnames4.previousamount}}</h6>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>

